import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { ContestUpgradesModule } from '@freelancer/contest-upgrades';
import {
  DatastoreContestBudgetRangesModule,
  DatastoreContestFeesModule,
  DatastoreContestMinimumBudgetClassificationsModule,
  DatastoreContestsModule,
  DatastoreContestViewContestsModule,
  DatastoreCurrenciesModule,
  DatastoreEquipmentModule,
  DatastoreJobClassifierModule,
  DatastoreLanguageDetectModule,
  DatastoreLanguagesModule,
  DatastorePostJobPageFormStateModule,
  DatastorePredictedSkillsModule,
  DatastoreProjectBudgetOptionsModule,
  DatastoreProjectUpgradeFeesModule,
  DatastoreProjectViewProjectsModule,
  DatastoreSkillBundlesModule,
  DatastoreSkillsModule,
  DatastoreSuggestedSkillsModule,
  DatastoreUserCalifornianStatusesModule,
  DatastoreUsersLocationModule,
  DatastoreUsersModule,
} from '@freelancer/datastore/collections';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PaymentsCartModule } from '@freelancer/payments-cart';
import { PipesModule } from '@freelancer/pipes';
import { ProjectUpgradesModule } from '@freelancer/project-upgrades';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FileUploadModule } from './file-upload/file-upload.module';
import { FooterComponent } from './footer/footer.component';
import { BannerComponent } from './form/banner/banner.component';
import { ContestBudgetComponent } from './form/contest/budget/budget.component';
import { ExpectedEntriesComponent } from './form/contest/budget/expected-entries/expected-entries.component';
import { ContestComponent } from './form/contest/contest.component';
import { ContestDurationTypeComponent } from './form/contest/duration-type/duration-type.component';
import { ContestDurationComponent } from './form/contest/duration/duration.component';
import { ContestAdvancedUpgradesComponent } from './form/contest/upgrades/advanced-upgrades/advanced-upgrades.component';
import { ContestUpgradesComponent } from './form/contest/upgrades/upgrades.component';
import { DescriptionComponent } from './form/description/description.component';
import { FormComponent } from './form/form.component';
import { JobTypeComponent } from './form/job-type/job-type.component';
import { ProjectDateComponent } from './form/project/date/date.component';
import { EquipmentComponent } from './form/project/equipment/equipment.component';
import { ProjectLocalQuestionComponent } from './form/project/local-question/local-question.component';
import { ProjectLocationComponent } from './form/project/location/location.component';
import { ProjectComponent } from './form/project/project.component';
import { ProjectAdvancedUpgradesComponent } from './form/project/upgrades/advanced-upgrades/advanced-upgrades.component';
import { ProjectUpgradesComponent } from './form/project/upgrades/upgrades.component';
import { SkillsComponent } from './form/skills/skills.component';
import { SuggestedSkillsComponent } from './form/skills/suggested-skills/suggested-skills.component';
import { SubmitComponent } from './form/summary/submit/submit.component';
import { SummaryComponent } from './form/summary/summary.component';
import { TitleComponent } from './form/title/title.component';
import { HeaderComponent } from './header/header.component';
import { ProjectBudgetModule } from './project-budget/project-budget.module';
import { ProjectLocationDetailsModule } from './project-location-details/project-location-details.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    ContestUpgradesModule,
    DatastoreContestBudgetRangesModule,
    DatastoreContestFeesModule,
    DatastoreContestMinimumBudgetClassificationsModule,
    DatastoreContestsModule,
    DatastoreContestViewContestsModule,
    DatastoreCurrenciesModule,
    DatastoreEquipmentModule,
    DatastoreJobClassifierModule,
    DatastoreLanguageDetectModule,
    DatastoreLanguagesModule,
    DatastoreSkillBundlesModule,
    DatastoreSkillsModule,
    DatastoreSuggestedSkillsModule,
    DatastorePostJobPageFormStateModule,
    DatastorePredictedSkillsModule,
    DatastoreProjectBudgetOptionsModule,
    DatastoreProjectUpgradeFeesModule,
    DatastoreProjectViewProjectsModule,
    DatastoreUserCalifornianStatusesModule,
    DatastoreUsersLocationModule,
    DatastoreUsersModule,
    FeatureFlagsModule,
    FileUploadModule,
    PaymentsCartModule,
    PipesModule,
    ProjectBudgetModule,
    TrackingModule,
    ProjectLocationDetailsModule,
    ProjectUpgradesModule,
    UiModule,
  ],
  exports: [
    BannerComponent,
    ContestAdvancedUpgradesComponent,
    ContestBudgetComponent,
    ContestComponent,
    ContestDurationComponent,
    ContestDurationTypeComponent,
    ContestUpgradesComponent,
    DescriptionComponent,
    EquipmentComponent,
    ExpectedEntriesComponent,
    FooterComponent,
    FormComponent,
    HeaderComponent,
    JobTypeComponent,
    ProjectAdvancedUpgradesComponent,
    ProjectComponent,
    ProjectLocalQuestionComponent,
    ProjectLocationComponent,
    ProjectDateComponent,
    ProjectUpgradesComponent,
    SkillsComponent,
    SubmitComponent,
    SummaryComponent,
    SuggestedSkillsComponent,
    TitleComponent,
  ],
  declarations: [
    BannerComponent,
    ContestAdvancedUpgradesComponent,
    ContestBudgetComponent,
    ContestComponent,
    ContestDurationComponent,
    ContestDurationTypeComponent,
    ContestUpgradesComponent,
    DescriptionComponent,
    EquipmentComponent,
    ExpectedEntriesComponent,
    FooterComponent,
    FormComponent,
    HeaderComponent,
    JobTypeComponent,
    ProjectAdvancedUpgradesComponent,
    ProjectComponent,
    ProjectLocalQuestionComponent,
    ProjectLocationComponent,
    ProjectDateComponent,
    ProjectUpgradesComponent,
    SkillsComponent,
    SubmitComponent,
    SummaryComponent,
    SuggestedSkillsComponent,
    TitleComponent,
  ],
})
export class JobPostSharedModule {}
